import { useRouteError } from 'react-router-dom';

export default function ErrorPage(){
    const error = useRouteError()
    return(
        //rest of the UI
        <div>Error : {error.status}, Sorry {error.message}</div>
    )
}